import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export function createOtpBlockStore(storageName) {
  return create(
    persist(
      (set) => ({
        blockExpiresAt: null,
        setOtpBlock: (blockExpiresAt) => set({ blockExpiresAt }),
        clearOtpBlock: () => set({ blockExpiresAt: null }),
      }),
      {
        name: storageName,
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: () => (state) => {
          if (state?.blockExpiresAt && state.blockExpiresAt <= Date.now()) {
            state.clearOtpBlock();
          }
        },
      },
    ),
  );
}

export const useLipaBidhaaOtpBlockStore = createOtpBlockStore(
  "lipa-bidhaa-block",
);

export const useFundsTransferOtpBlockStore = createOtpBlockStore(
  "funds-transfer-block",
);
